import { render, staticRenderFns } from "./add-money-pop.vue?vue&type=template&id=820b5336&scoped=true&"
import script from "./add-money-pop.vue?vue&type=script&lang=js&"
export * from "./add-money-pop.vue?vue&type=script&lang=js&"
import style0 from "./add-money-pop.vue?vue&type=style&index=0&id=820b5336&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820b5336",
  null
  
)

export default component.exports